import React, { useState } from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { useForm } from "react-hook-form";
import Inputs from "../../share/input/Inputs";
import { BtnPrimary } from "../../share/buttons/Btn";
import useFetch from "../../../Hooks/useFetch";
import MessageQuill from "../Message/MessageQuill";
function NewQuestion({ close, surveyType, getSurveysQuestions }) {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const [call, setCall] = useState(null);
    const [description, setDescription] = useState("");
    const [surveyQuestion, setSurveyQuestion] = useState({
        bootcamp: null,
        question_type: "",
        question_text: "",
        question_option_one: "",
        question_option_two: "",
        question_option_three: "",
        question_option_four: "",
    });

    const newSurveyQuestion = useFetch({
        method: "POST",
        url: `BootCampSurveyQuestionService`,
        noHeader: false,
        caller: getSurveysQuestions,
        trigger: false,
        data: call,
    });

    const submitForm = () => {
        console.log("submit test");

        const formData = new FormData();

        //TODO : id bootcamp dynamic she
        formData.append("bootcamp", 11);
        formData.append("survey_type", surveyType);
        formData.append("question_type", surveyQuestion.question_type);
        formData.append("question_text", surveyQuestion.question_text);
        if (surveyQuestion.question_type === "Test") {
            formData.append(
                "question_option_one",
                surveyQuestion.question_option_one
            );
            formData.append(
                "question_option_two",
                surveyQuestion.question_option_two
            );
            formData.append(
                "question_option_three",
                surveyQuestion.question_option_three
            );
            formData.append(
                "question_option_four",
                surveyQuestion.question_option_four
            );
        }

        setCall(formData);
        newSurveyQuestion.reFetch();

        setSurveyQuestion({
            bootcamp: null,
            survey_type: "",
            question_type: "",
            question_text: "",
            question_option_one: "",
            question_option_two: "",
            question_option_three: "",
            question_option_four: "",
        });

        close();
    };

    return (
        <div className="AddnewsupportTicket relative ">
            <button
                onClick={() => close(false)}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className=" text-center text-[#77498F] text-[16px] mb-16">
                ایجاد سوال جدید برای نظر سنجی پایان دوره
            </h3>
            <form onSubmit={handleSubmit(submitForm)}>
                <div className=" flex items-center ">
                    <p className=" text-[#212121E5] text-[1.8rem] font-normal leading-[3.2rem] ml-[4rem]">
                        نوع سوال:
                    </p>
                    <div className=" flex flex-row items-center justify-between">
                        <div className=" flex items-center justify-start ml-[4rem]">
                            <label
                                htmlFor="4go"
                                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
                            >
                                <input
                                    {...register("course", { required: true })}
                                    type="radio"
                                    name="coursetype"
                                    value="4go"
                                    className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                                    id="4go"
                                    checked={
                                        surveyQuestion.question_type === "Test"
                                            ? true
                                            : false
                                    }
                                    onClick={() =>
                                        setSurveyQuestion({
                                            ...surveyQuestion,
                                            question_type: "Test",
                                        })
                                    }
                                />
                                چهار گزینه ای
                            </label>
                        </div>
                        <div className=" flex items-center justify-start">
                            <label
                                htmlFor="تشریحی"
                                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
                            >
                                <input
                                    {...register("course", { required: true })}
                                    type="radio"
                                    name="coursetype"
                                    value="تشریحی"
                                    className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                                    id="تشریحی"
                                    checked={
                                        surveyQuestion.question_type ===
                                        "Descriptive"
                                            ? true
                                            : false
                                    }
                                    onClick={() =>
                                        setSurveyQuestion({
                                            ...surveyQuestion,
                                            question_type: "Descriptive",
                                        })
                                    }
                                />
                                تشریحی
                            </label>
                        </div>
                        {"question" === 1 && (
                            <div className=" flex items-center justify-start mr-[4rem]">
                                <label
                                    htmlFor="فایل"
                                    className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
                                >
                                    <input
                                        {...register("course", {
                                            required: true,
                                        })}
                                        type="radio"
                                        name="coursetype"
                                        value="فایل"
                                        className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                                        id="فایل"
                                        checked={
                                            surveyQuestion.question_type ===
                                            "File"
                                                ? true
                                                : false
                                        }
                                        onClick={() =>
                                            setSurveyQuestion({
                                                ...surveyQuestion,
                                                question_type: "File",
                                            })
                                        }
                                    />
                                    فایل
                                </label>
                            </div>
                        )}
                    </div>
                </div>
                {/* {question === 1 && (
                    <div className=" flex items-center mt-[2.3rem]">
                        <p className=" text-[#212121E5] text-[1.8rem] font-normal leading-[3.2rem] ml-[4rem]">
                            گروه سوال:
                        </p>
                        <div className=" flex flex-row items-center justify-between">
                            <div className=" flex items-center justify-start ml-[4rem]">
                                <label
                                    htmlFor="شخصی"
                                    className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
                                >
                                    <input
                                        {...register("course", {
                                            required: true,
                                        })}
                                        type="radio"
                                        name="coursetype1"
                                        value="شخصی"
                                        className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                                        id="شخصی"
                                        checked={
                                            surveyQuestion.question_type ===
                                            "Test"
                                                ? true
                                                : false
                                        }
                                        onClick={() =>
                                            setSurveyQuestion({
                                                ...surveyQuestion,
                                                question_type: "Test",
                                            })
                                        }
                                    />
                                    چهار گزینه ای
                                </label>
                            </div>
                            <div className=" flex items-center justify-start ml-[0.8rem]">
                                <label
                                    htmlFor="شخصیتی"
                                    className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
                                >
                                    <input
                                        {...register("course", {
                                            required: true,
                                        })}
                                        type="radio"
                                        name="coursetype1"
                                        value="شخصیتی"
                                        className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                                        id="شخصیتی"
                                        checked={
                                            questionType === 1 ? true : false
                                        }
                                        onClick={() => setQuestionType(1)}
                                    />
                                    شخصیتی
                                </label>
                            </div>
                            <div className=" flex items-center justify-start ml-[0.8rem]">
                                <label
                                    htmlFor="کاری"
                                    className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
                                >
                                    <input
                                        {...register("course", {
                                            required: true,
                                        })}
                                        type="radio"
                                        name="coursetype1"
                                        value="کاری"
                                        className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                                        id="کاری"
                                        checked={
                                            questionType === 1 ? true : false
                                        }
                                        onClick={() => setQuestionType(1)}
                                    />{" "}
                                    کاری
                                </label>
                            </div>
                            <div className=" flex items-center justify-start ">
                                <label
                                    htmlFor="تحصیلی"
                                    className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
                                >
                                    <input
                                        {...register("course", {
                                            required: true,
                                        })}
                                        type="radio"
                                        name="coursetype1"
                                        value="تحصیلی"
                                        className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                                        id="تحصیلی"
                                        checked={
                                            questionType === 1 ? true : false
                                        }
                                        onClick={() => setQuestionType(1)}
                                    />
                                    تحصیلی
                                </label>
                            </div>
                        </div>
                    </div>
                )} */}
                {surveyQuestion.question_type === "Test" && (
                    <div>
                        <input
                            register={{
                                required: {
                                    value: true,
                                    message: "Enter Name",
                                },
                            }}
                            type="text"
                            name="name"
                            control={control}
                            placeholder="متن سوال جدید"
                            className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mt-[1.6rem] input"
                            onChange={(e) =>
                                setSurveyQuestion({
                                    ...surveyQuestion,
                                    question_text: e.target.value,
                                })
                            }
                        />
                        <input
                            register={{
                                required: {
                                    value: true,
                                    message: "Enter Name",
                                },
                            }}
                            type="text"
                            name="name"
                            control={control}
                            placeholder="گزینه اول"
                            className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] my-[1.6rem] input"
                            onChange={(e) =>
                                setSurveyQuestion({
                                    ...surveyQuestion,
                                    question_option_one: e.target.value,
                                })
                            }
                        />
                        <input
                            register={{
                                required: {
                                    value: true,
                                    message: "Enter Name",
                                },
                            }}
                            type="text"
                            name="name"
                            control={control}
                            placeholder="گزینه دوم"
                            className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem] input"
                            onChange={(e) =>
                                setSurveyQuestion({
                                    ...surveyQuestion,
                                    question_option_two: e.target.value,
                                })
                            }
                        />
                        <input
                            register={{
                                required: {
                                    value: true,
                                    message: "Enter Name",
                                },
                            }}
                            type="text"
                            name="name"
                            control={control}
                            placeholder="گزینه سوم"
                            className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem] input"
                            onChange={(e) =>
                                setSurveyQuestion({
                                    ...surveyQuestion,
                                    question_option_three: e.target.value,
                                })
                            }
                        />
                        <input
                            register={{
                                required: {
                                    value: true,
                                    message: "Enter Name",
                                },
                            }}
                            type="text"
                            name="name"
                            control={control}
                            placeholder="گزینه چهارم"
                            className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] input"
                            onChange={(e) =>
                                setSurveyQuestion({
                                    ...surveyQuestion,
                                    question_option_four: e.target.value,
                                })
                            }
                        />
                    </div>
                )}

                {surveyQuestion.question_type === "Descriptive" && (
                    <div>
                        <input
                            register={{
                                required: {
                                    value: true,
                                    message: "Enter Name",
                                },
                            }}
                            type="text"
                            name="name"
                            control={control}
                            placeholder="متن سوال جدید"
                            className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] my-[1.6rem] input"
                            onChange={(e) =>
                                setSurveyQuestion({
                                    ...surveyQuestion,
                                    question_text: e.target.value,
                                })
                            }
                        />
                        <MessageQuill
                            placeholder="توضیحات *"
                            value={description}
                            setValue={setDescription}
                        />
                    </div>
                )}
                <div className="text-left">
                    <BtnPrimary
                        className="py-[20px] px-[25px] mt-[3rem]"
                        text="ثبت سوال"
                        onClick={(e) => {
                            e.preventDefault();
                            submitForm();
                        }}
                    />
                </div>
            </form>
        </div>
    );
}

export default NewQuestion;
